(function () {
  'use strict';

  const dataNode = document.getElementById('hz-configurator-categories');
  const categories = (function () {
    if (!dataNode) return [];
    try {
      return JSON.parse(dataNode.textContent) || [];
    } catch (e) {
      return [];
    }
  })();
  const PRICE_TEXT_LARGE = dataNode ? parseFloat(dataNode.dataset.priceTextLarge) || 0 : 0;
  const PRICE_LOGO_LARGE = dataNode ? parseFloat(dataNode.dataset.priceLogoLarge) || 0 : 0;
  const PRICE_LOGO_SMALL = dataNode ? parseFloat(dataNode.dataset.priceLogoSmall) || 0 : 0;
  const PRICE_ARM_PLACEMENT = dataNode ? parseFloat(dataNode.dataset.priceArmPlacement) || 0 : 0;
  const PRICE_HAT_EXTRA_TEXT = dataNode ? parseFloat(dataNode.dataset.priceHatExtraText) || 0 : 0;
  // Note: read via getAttribute, not .dataset — a hyphen followed by a digit (e.g. "-7") isn't
  // camelCased by the browser's dataset algorithm (only hyphen+letter is), so .surchargeVariant7
  // would silently never match the data-surcharge-variant-7 attribute.
  const SURCHARGE_VARIANTS = dataNode
    ? {
        7: dataNode.getAttribute('data-surcharge-variant-7') || null,
        10: dataNode.getAttribute('data-surcharge-variant-10') || null,
        20: dataNode.getAttribute('data-surcharge-variant-20') || null,
      }
    : {};
  const CART_VARIANT_ID = dataNode ? dataNode.dataset.variantId : null;
  const DESIGN_MODE = dataNode ? dataNode.dataset.designMode === 'true' : false;
  const PREFERS_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lastRenderedStep = null;

  const i18nNode = document.getElementById('hz-configurator-i18n');
  const I18N = (function () {
    if (!i18nNode) return {};
    try {
      return JSON.parse(i18nNode.textContent) || {};
    } catch (e) {
      return {};
    }
  })();

  const fontImagesNode = document.getElementById('hz-configurator-font-images');
  const FONT_IMAGES = (function () {
    if (!fontImagesNode) return {};
    try {
      return JSON.parse(fontImagesNode.textContent) || {};
    } catch (e) {
      return {};
    }
  })();

  const KIDS_SIZES = ['3/4 (98/104)', '5/6 (110/116)', '7/8 (122/128)', '9/10 (134/140)', '11/12 (146/152)'];
  const ADULT_SIZES = ['S', 'M', 'L', 'XL', 'XXL'];

  const COLORS = [
    { label: 'White', hex: '#FFFFFF' },
    { label: 'Black', hex: '#4A3B36' },
    { label: 'Navy', hex: '#22304A' },
    { label: 'Grey', hex: '#8A8177' },
    { label: 'Red', hex: '#DC143C' },
    { label: 'Beige', hex: '#E2DCCB' },
    { label: 'Sage', hex: '#A794DD' },
    { label: 'Sky Blue', hex: '#7893A6' },
  ];

  const PLACEMENTS = [
    { label: 'Left Chest', large: false },
    { label: 'Right Chest', large: false },
    { label: 'Middle', large: false, size: '(10×10cm)' },
    { label: 'Middle', large: true, size: '(13×18cm)', key: 'Middle-large' },
    { label: 'Hand/Arm Side', large: false, key: 'arm' },
  ];

  const FONT_STYLES = [
    'Block 1',
    'Block 2',
    'Anaconda',
    'Athletica',
    'Castle',
    'Bodoni',
    'Chancery',
    'Flair Script',
    'Typewriter',
    'Souvenir',
  ];

  // The 30 thread colors shown on the reference chart photo — customers must type the exact
  // number or name of one of these (case-insensitive), so orders never arrive with a thread
  // color that doesn't actually exist.
  const THREAD_COLORS = [
    { number: '001', name: 'White' },
    { number: '005', name: 'Silver' },
    { number: '900', name: 'Black' },
    { number: '843', name: 'Beige' },
    { number: '707', name: 'Dark Gray' },
    { number: '010', name: 'Cream Brown' },
    { number: '323', name: 'Light Brown' },
    { number: '058', name: 'Dark Brown' },
    { number: '339', name: 'Clay Brown' },
    { number: '214', name: 'Deep Gold' },
    { number: '085', name: 'Pink' },
    { number: '086', name: 'Deep Rose' },
    { number: '079', name: 'Salmon Pink' },
    { number: '620', name: 'Magenta' },
    { number: '810', name: 'Light Lilac' },
    { number: '614', name: 'Purple' },
    { number: '612', name: 'Lilac' },
    { number: '017', name: 'Light Blue' },
    { number: '019', name: 'Sky Blue' },
    { number: '405', name: 'Blue' },
    { number: '420', name: 'Electric Blue' },
    { number: '007', name: 'Prussian Blue' },
    { number: '070', name: 'Cornflower Blue' },
    { number: '704', name: 'Pewter' },
    { number: '502', name: 'Mint Green' },
    { number: '027', name: 'Fresh Green' },
    { number: '507', name: 'Emerald Green' },
    { number: '513', name: 'Lime Green' },
    { number: '515', name: 'Moss Green' },
    { number: '205', name: 'Yellow' },
  ];

  function isValidThreadColor(value) {
    const v = (value || '').trim().toLowerCase();
    if (!v) return false;
    return THREAD_COLORS.some((c) => c.number.toLowerCase() === v || c.name.toLowerCase() === v);
  }

  function colorLabel(label) {
    return (I18N.colors && I18N.colors[label]) || label;
  }
  function placementLabel(label) {
    return (I18N.placementLabels && I18N.placementLabels[label]) || label;
  }

  function accordionData() {
    const cat = currentCategory();
    const details = (cat && cat.description && cat.description.trim()) || I18N.defaultProductDetails;
    return [
      { title: I18N.productDetailsTitle, body: details },
      { title: I18N.accordionMadeTitle, body: I18N.accordionMadeBody },
      { title: I18N.accordionShippingTitle, body: I18N.accordionShippingBody },
    ];
  }

  const STEP_KEYS = ['category', 'style', 'size', 'color', 'type', 'placement', 'personalize', 'upload'];
  const STEP_LABEL_MAP = {
    category: I18N.stepCategory,
    style: I18N.stepStyle,
    size: I18N.stepSize,
    color: I18N.stepColor,
    type: I18N.stepType,
    placement: I18N.stepPlacement,
    personalize: I18N.stepPersonalize,
  };

  const state = {
    step: 0,
    categoryId: categories[0] ? categories[0].id : null,
    groupName: null,
    activeImage: 0,
    size: null,
    color: null,
    colorHex: null,
    colorImage: null,
    placement: null,
    placementLarge: false,
    personalizeType: null,
    textLines: [],
    fontStyle: null,
    threadColorNumber: '',
    hatExtraText: false,
    hatExtraTextValue: '',
    fileName: '',
    qty: 1,
    justAdded: false,
    cartError: null,
    adding: false,
    openAccordion: null,
  };

  function esc(str) {
    const div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function currentCategory() {
    return categories.find((c) => c.id === state.categoryId) || null;
  }

  function sizesForCategory() {
    const cat = currentCategory();
    if (cat && cat.sizeType === 'adult') return ADULT_SIZES;
    if (cat && cat.sizeType === 'one_size') return [];
    return KIDS_SIZES;
  }

  // Real-inventory helpers. A category only carries `stock`/hasSizeOption/hasColorOption when it
  // has a linked Shopify product (hasLinkedProduct) — everything else keeps working as before.
  // Stock is keyed by size alone, color alone, or a composite "size|||color" string depending on
  // which option(s) the linked product actually has — see stockKey().
  const STOCK_KEY_DELIM = '|||';
  const SINGLE_KEY = '*';

  function normalizeKeyPart(s) {
    return (s || '').trim().toLowerCase();
  }

  function stockKey(cat, sizeLabel, colorLabel) {
    if (cat.sizeType === 'one_size') {
      return cat.hasColorOption ? colorLabel || '' : SINGLE_KEY;
    }
    return cat.hasColorOption ? `${sizeLabel || ''}${STOCK_KEY_DELIM}${colorLabel || ''}` : sizeLabel || '';
  }

  function stockEntry(cat, sizeLabel, colorLabel) {
    if (!cat || !cat.hasLinkedProduct || !cat.stock) return null;
    const key = stockKey(cat, sizeLabel, colorLabel);
    if (cat.stock[key]) return cat.stock[key];
    if (key === SINGLE_KEY) return null;
    const targetSize = normalizeKeyPart(sizeLabel);
    const targetColor = normalizeKeyPart(colorLabel);
    const foundKey = Object.keys(cat.stock).find((k) => {
      if (!cat.hasColorOption) {
        return normalizeKeyPart(k) === (cat.sizeType === 'one_size' ? targetColor : targetSize);
      }
      const parts = k.split(STOCK_KEY_DELIM);
      if (cat.sizeType === 'one_size') return normalizeKeyPart(parts[0]) === targetColor;
      return normalizeKeyPart(parts[0]) === targetSize && normalizeKeyPart(parts[1]) === targetColor;
    });
    return foundKey ? cat.stock[foundKey] : null;
  }

  // A category can define its own real colors (with optional photos); otherwise, if it has a
  // linked product with a real Color option, build swatches straight from that option's actual
  // values so customer-visible choices always match what Shopify can fulfill; otherwise fall back
  // to the default palette. Takes an explicit cat (not currentCategory()) so tile-level checks on
  // OTHER categories (Style step options, other Category tiles) always use the right category's colors.
  function colorsFor(cat) {
    if (cat && cat.colors && cat.colors.length) return cat.colors;
    if (cat && cat.hasColorOption && cat.matchedColorValues && cat.matchedColorValues.length) {
      return cat.matchedColorValues.map((label) => ({ label, hex: '#CFC6BA' }));
    }
    return COLORS;
  }

  function colorsForCategory() {
    return colorsFor(currentCategory());
  }

  function isSizeAvailable(cat, sizeLabel) {
    if (!cat || !cat.hasLinkedProduct) return true;
    if (!cat.hasColorOption) {
      const entry = stockEntry(cat, sizeLabel, null);
      return !!(entry && entry.available);
    }
    return colorsFor(cat).some((c) => {
      const entry = stockEntry(cat, sizeLabel, c.label);
      return entry && entry.available;
    });
  }

  function isColorAvailable(cat, sizeLabel, colorLabel) {
    if (!cat || !cat.hasLinkedProduct) return true;
    const size = cat.sizeType === 'one_size' ? null : sizeLabel;
    const entry = stockEntry(cat, size, colorLabel);
    return !!(entry && entry.available);
  }

  function firstAvailableSize(cat) {
    const sizes = cat && cat.sizeType === 'adult' ? ADULT_SIZES : KIDS_SIZES;
    if (!cat || !cat.hasLinkedProduct) return sizes[0] || null;
    return sizes.find((sz) => isSizeAvailable(cat, sz)) || null;
  }

  function hasAnyColorAvailable(cat) {
    if (!cat || !cat.hasLinkedProduct) return true;
    if (!cat.hasColorOption) {
      const entry = stockEntry(cat, null, null);
      return !!(entry && entry.available);
    }
    return colorsFor(cat).some((c) => {
      const entry = stockEntry(cat, null, c.label);
      return entry && entry.available;
    });
  }

  // Tile-level availability (Category/Style steps). Sized categories are always tile-clickable —
  // their per-size availability is handled in the Size step instead. Only one_size categories
  // (no Size step to gray out) can make the whole tile unavailable.
  function isCategoryTileAvailable(cat) {
    if (!cat || cat.sizeType !== 'one_size') return true;
    return hasAnyColorAvailable(cat);
  }

  // The real Shopify variant to add to cart. Untracked categories keep using the single fixed
  // CART_VARIANT_ID as before; linked categories resolve the variant matching the chosen size
  // and/or color. Returns null if nothing resolves (sold out).
  function resolveVariantId(cat) {
    if (!cat || !cat.hasLinkedProduct) return CART_VARIANT_ID;
    const sizeLabel = cat.sizeType === 'one_size' ? null : state.size;
    const entry = stockEntry(cat, sizeLabel, state.color);
    return entry && entry.available ? entry.id : null;
  }

  // Categories flagged "middle placement only" (e.g. hats) only offer the small Middle placement.
  // Hand/Arm Side is a text-only placement (a logo doesn't have a character limit to fit into a sleeve).
  function placementsForCategory() {
    const cat = currentCategory();
    if (cat && cat.placementRestricted) {
      return PLACEMENTS.filter((p) => p.label === 'Middle' && !p.large);
    }
    if (state.personalizeType === 'logo') {
      return PLACEMENTS.filter((p) => p.key !== 'arm');
    }
    return PLACEMENTS;
  }

  // How many text lines/characters fit the currently selected placement's embroidery area.
  // Hats (Middle, 10x10cm only) and Hand/Arm Side keep their original small limits; a garment's
  // 10x10cm placement (Middle/Left/Right Chest) gets a taller field, and its 13x18cm placement
  // (Middle only) gets a still-larger one.
  function textLineLimits() {
    const cat = currentCategory();
    const restricted = !!(cat && cat.placementRestricted);
    if (state.placement === 'Hand/Arm Side') return { maxLines: 1, maxChars: 8 };
    if (restricted) return { maxLines: 2, maxChars: 12 };
    if (state.placementLarge) return { maxLines: 7, maxChars: 18 };
    return { maxLines: 4, maxChars: 12 };
  }

  // Extra charge for a given placement, based on the already-chosen personalization type.
  function feeForPlacement(p) {
    if (!p) return 0;
    if (p.key === 'arm') return PRICE_ARM_PLACEMENT;
    if (state.personalizeType === 'logo') return p.large ? PRICE_LOGO_LARGE : PRICE_LOGO_SMALL;
    if (state.personalizeType === 'text') return p.large ? PRICE_TEXT_LARGE : 0;
    return 0;
  }

  // Real, chargeable surcharges for the current selection — mirrors feeForPlacement()/calcPrice()'s
  // logic exactly, but returns each distinct reason separately (placement/type fee, hat extra text)
  // so every applicable surcharge can be added to the cart as its own real-priced line item.
  function surchargeReasons() {
    const cat = currentCategory();
    const reasons = [];
    const p = PLACEMENTS.find((x) => x.label === state.placement && x.large === state.placementLarge);
    const placementFee = feeForPlacement(p);
    if (p && placementFee > 0) {
      let label = placementLabel(p.label);
      if (state.personalizeType === 'logo') label = I18N.personalizeTypeLogo || label;
      reasons.push({ amount: placementFee, label: label });
    }
    if (cat && cat.placementRestricted && state.hatExtraText && PRICE_HAT_EXTRA_TEXT > 0) {
      reasons.push({ amount: PRICE_HAT_EXTRA_TEXT, label: I18N.hatExtraTextLabel || 'Extra back/side text' });
    }
    return reasons;
  }

  // Looks up the real Shopify variant for a given surcharge amount (the "Embroidery Surcharge"
  // product's CHF 7/10/20 variants). Returns null if no matching variant is configured.
  function surchargeVariantId(amount) {
    return SURCHARGE_VARIANTS[amount] || null;
  }

  // Categories sharing a group name (e.g. "Kinder Hat") are collapsed into one tile in Category step;
  // picking that tile reveals the Style step listing just that group's categories.
  function categoryTiles() {
    const seen = new Set();
    const tiles = [];
    categories.forEach((cat) => {
      if (cat.groupName) {
        if (!seen.has(cat.groupName)) {
          seen.add(cat.groupName);
          tiles.push({ isGroup: true, key: cat.groupName, label: cat.groupName });
        }
      } else {
        tiles.push({ isGroup: false, key: cat.id, label: cat.name });
      }
    });
    return tiles;
  }

  // One-size categories (e.g. a hat style that only comes in one size) skip the Size step entirely.
  // A "Text" personalization needs no file upload, so the Upload step is skipped in that case too.
  // The Style step only exists once a grouped tile (e.g. "Kinder Hat") has been picked in Category.
  function activeStepKeys() {
    const cat = currentCategory();
    let keys = STEP_KEYS;
    if (!state.groupName) {
      keys = keys.filter((k) => k !== 'style');
    }
    if (cat && cat.sizeType === 'one_size') {
      keys = keys.filter((k) => k !== 'size');
    }
    if (state.personalizeType === 'text') {
      keys = keys.filter((k) => k !== 'upload');
    }
    return keys;
  }

  // For the "text" personalization path, a name/text, a font style and a thread color number
  // are all required before checkout — logo uploads are unaffected by this.
  function isPersonalizationComplete() {
    if (state.personalizeType !== 'text') return true;
    const hasText = state.textLines.some((line) => line.trim());
    return hasText && !!state.fontStyle && isValidThreadColor(state.threadColorNumber);
  }

  // Step completeness gates forward navigation (tabs + Next). Back is never gated.
  function isStepComplete(i) {
    const key = activeStepKeys()[i];
    if (key === 'category') return !!state.categoryId || !!state.groupName;
    if (key === 'style') return !!state.categoryId;
    if (key === 'size') return !!state.size;
    if (key === 'color') return !!state.color;
    if (key === 'type') return !!state.personalizeType;
    if (key === 'placement') return !!state.placement;
    if (key === 'personalize') return isPersonalizationComplete();
    return true; // Upload (final) never blocks
  }

  function maxUnlockedStep() {
    const total = activeStepKeys().length;
    for (let i = 1; i < total; i++) {
      if (!isStepComplete(i - 1)) return i - 1;
    }
    return total - 1;
  }

  // Finalizes a real (leaf) category selection — used both for standalone tiles clicked directly in
  // Category step, and for style tiles clicked in the Style step (within a group).
  function finalizeCategory(id) {
    state.categoryId = id;
    const cat = currentCategory();
    // Derive groupName from the resolved category itself, so a stale value from a previously
    // browsed group can't leak in when a standalone tile (no group) is picked directly.
    state.groupName = cat && cat.groupName ? cat.groupName : null;
    state.size = cat && cat.sizeType === 'one_size' ? I18N.oneSizeLabel || 'One size' : null;
    state.color = null;
    state.colorHex = null;
    state.colorImage = null;
    state.activeImage = 0;
    state.personalizeType = null;
    state.placement = null;
    state.placementLarge = false;
    state.textLines = [];
    state.fontStyle = null;
    state.threadColorNumber = '';
    state.hatExtraText = false;
    state.hatExtraTextValue = '';
    const keys = activeStepKeys();
    const target = keys.includes('size') ? 'size' : 'color';
    state.step = keys.indexOf(target);
    render();
  }

  // Picking a grouped tile (e.g. "Kinder Hat") in Category step moves into the Style step
  // instead of finalizing a category — the real leaf category is chosen there.
  function selectGroup(groupName) {
    state.groupName = groupName;
    state.categoryId = null;
    state.step = activeStepKeys().indexOf('style');
    render();
  }

  function goTo(step) {
    if (step > maxUnlockedStep()) return;
    state.step = step;
    render();
  }
  function next() {
    if (!isStepComplete(state.step)) return;
    state.step = Math.min(state.step + 1, activeStepKeys().length - 1);
    render();
  }
  function back() {
    state.step = Math.max(state.step - 1, 0);
    render();
  }

  const el = {
    galleryMain: document.getElementById('gallery-main'),
    galleryThumbs: document.getElementById('gallery-thumbs'),
    priceVal: document.getElementById('price-val'),
    surchargeBadge: document.getElementById('surcharge-badge'),
    tabs: document.getElementById('tabs'),
    progressBar: document.getElementById('progress-bar'),
    stepNumberLabel: document.getElementById('step-number-label'),
    stepsToGoLabel: document.getElementById('steps-to-go-label'),
    stepContent: document.getElementById('step-content'),
    backBtn: document.getElementById('back-btn'),
    nextBtn: document.getElementById('next-btn'),
    cartControls: document.getElementById('cart-controls'),
    qtyVal: document.getElementById('qty-val'),
    qtyInc: document.getElementById('qty-inc'),
    qtyDec: document.getElementById('qty-dec'),
    addToCartBtn: document.getElementById('add-to-cart-btn'),
    justAdded: document.getElementById('just-added'),
    cartErrorEl: document.getElementById('cart-error'),
    accordion: document.getElementById('accordion'),
    inventoryWarnings: document.getElementById('hz-inventory-warnings'),
  };

  function renderGallery() {
    const cat = currentCategory();
    const images = cat && cat.images ? cat.images : [];
    const activeSrc = state.colorImage || images[state.activeImage] || images[0];

    if (activeSrc) {
      el.galleryMain.style.background = '#FFFFFF';
      el.galleryMain.innerHTML = `<img src="${esc(activeSrc)}" alt="${esc(cat.name)}" style="width:100%; height:100%; object-fit:contain;">`;
    } else {
      el.galleryMain.style.background = 'repeating-linear-gradient(135deg, #FFFFFF, #FFFFFF 14px, #FBF1E3 14px, #FBF1E3 28px)';
      el.galleryMain.innerHTML = `<span style="font-family:ui-monospace,monospace; font-size:13px; color:#8A8177; background:rgba(255,255,255,0.6); padding:6px 12px; border-radius:8px;">${I18N.productPhotoLabel}${cat ? ' — ' + esc(cat.name) : ''}</span>`;
    }

    if (images.length > 1) {
      el.galleryThumbs.style.display = '';
      el.galleryThumbs.innerHTML = images
        .map((src, i) => {
          const active = i === state.activeImage;
          return `<button type="button" data-idx="${i}" style="flex:none; width:74px; height:74px; border-radius:12px; border:2px solid ${active ? '#A794DD' : 'transparent'}; padding:0; cursor:pointer; overflow:hidden; background:#FFFFFF;"><img src="${esc(src)}" style="width:100%; height:100%; object-fit:contain; display:block;" alt=""></button>`;
        })
        .join('');
      el.galleryThumbs.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => {
          state.activeImage = parseInt(btn.dataset.idx, 10);
          state.colorImage = null;
          renderGallery();
        });
      });
    } else {
      el.galleryThumbs.style.display = 'none';
      el.galleryThumbs.innerHTML = '';
    }
  }

  function calcPrice() {
    const cat = currentCategory();
    let price = cat ? cat.basePrice : 0;
    const p = PLACEMENTS.find((x) => x.label === state.placement && x.large === state.placementLarge);
    price += feeForPlacement(p);
    if (cat && cat.placementRestricted && state.hatExtraText) price += PRICE_HAT_EXTRA_TEXT;
    return price;
  }

  function updatePrice() {
    const cat = currentCategory();
    const base = cat ? cat.basePrice : 0;
    const extras = calcPrice() - base;
    el.priceVal.textContent = calcPrice().toFixed(2);
    el.surchargeBadge.style.display = extras > 0 ? '' : 'none';
    el.surchargeBadge.textContent = extras > 0 ? `+CHF ${extras.toFixed(2)}` : '';
    // Also refresh Add to Cart's enabled state here — this runs on every keystroke in the
    // personalize step (text lines, thread color), unlike the full render() which would wipe
    // and recreate the inputs (losing focus/cursor) on every character typed.
    el.addToCartBtn.disabled = state.adding || !isPersonalizationComplete();
    el.addToCartBtn.style.opacity = el.addToCartBtn.disabled ? '0.5' : '1';
    el.addToCartBtn.style.cursor = el.addToCartBtn.disabled ? 'not-allowed' : 'pointer';
  }

  function stepContentHtml() {
    if (!categories.length) {
      return `<p style="font-size:14px; color:#4A3B36; opacity:0.7;">${I18N.noCategories}</p>`;
    }

    const key = activeStepKeys()[state.step];

    if (key === 'category') {
      const activeLabel = state.groupName ? state.groupName : currentCategory() ? currentCategory().name : null;
      return `<h3 style="font-weight:600; font-size:19px; margin:0 0 4px;">${I18N.chooseCategoryTitle}</h3>
        <p style="font-size:13px; color:#4A3B36; opacity:0.6; margin:0 0 16px;">${activeLabel ? esc(activeLabel) : I18N.chooseCategoryPlaceholder}</p>
        <div style="display:grid; grid-template-columns:repeat(2,1fr); gap:10px; margin-bottom:24px;">
          ${categoryTiles()
            .map((tile) => {
              const active = tile.isGroup ? state.groupName === tile.key : state.categoryId === tile.key;
              if (!tile.isGroup) {
                const tileCat = categories.find((c) => c.id === tile.key);
                if (!isCategoryTileAvailable(tileCat)) {
                  return `<button type="button" disabled style="border:2px solid rgba(74,59,54,0.12); background:#fff; color:rgba(74,59,54,0.35); border-radius:12px; padding:14px 10px; font-size:14px; font-weight:700; cursor:not-allowed; text-decoration:line-through;">${esc(tile.label)} <span style="text-decoration:none; font-weight:600; font-size:10.5px; opacity:0.85;">(${I18N.outOfStockLabel})</span></button>`;
                }
              }
              const attr = tile.isGroup ? `data-group="${esc(tile.key)}"` : `data-category="${esc(tile.key)}"`;
              return `<button type="button" ${attr} style="border:2px solid ${active ? '#A794DD' : 'rgba(74,59,54,0.2)'}; background:${active ? '#A794DD' : '#fff'}; color:${active ? '#FBF1E3' : '#4A3B36'}; border-radius:12px; padding:14px 10px; font-size:14px; font-weight:700; cursor:pointer;">${esc(tile.label)}</button>`;
            })
            .join('')}
        </div>`;
    }

    if (key === 'style') {
      const options = categories.filter((c) => c.groupName === state.groupName);
      return `<h3 style="font-weight:600; font-size:19px; margin:0 0 4px;">${I18N.chooseStyleTitle}</h3>
        <p style="font-size:13px; color:#4A3B36; opacity:0.6; margin:0 0 16px;">${currentCategory() ? esc(currentCategory().name) : I18N.chooseCategoryPlaceholder}</p>
        <div style="display:grid; grid-template-columns:repeat(2,1fr); gap:10px; margin-bottom:24px;">
          ${options
            .map((cat) => {
              const active = state.categoryId === cat.id;
              if (!isCategoryTileAvailable(cat)) {
                return `<button type="button" disabled style="border:2px solid rgba(74,59,54,0.12); background:#fff; color:rgba(74,59,54,0.35); border-radius:12px; padding:14px 10px; font-size:14px; font-weight:700; cursor:not-allowed; text-decoration:line-through;">${esc(cat.name)} <span style="text-decoration:none; font-weight:600; font-size:10.5px; opacity:0.85;">(${I18N.outOfStockLabel})</span></button>`;
              }
              return `<button type="button" data-category="${esc(cat.id)}" style="border:2px solid ${active ? '#A794DD' : 'rgba(74,59,54,0.2)'}; background:${active ? '#A794DD' : '#fff'}; color:${active ? '#FBF1E3' : '#4A3B36'}; border-radius:12px; padding:14px 10px; font-size:14px; font-weight:700; cursor:pointer;">${esc(cat.name)}</button>`;
            })
            .join('')}
        </div>`;
    }

    if (key === 'size') {
      const cat = currentCategory();
      const sizes = sizesForCategory();
      return `<h3 style="font-weight:600; font-size:19px; margin:0 0 4px;">${I18N.chooseSizeTitle}</h3>
        <p style="font-size:13px; color:#4A3B36; opacity:0.6; margin:0 0 16px;">${state.size ? esc(state.size) : I18N.notSelected}</p>
        <div style="display:flex; gap:10px; flex-wrap:wrap; margin-bottom:24px;">
          ${sizes
            .map((sz) => {
              const active = state.size === sz;
              const available = isSizeAvailable(cat, sz);
              if (!available) {
                return `<button type="button" disabled style="border:2px solid rgba(74,59,54,0.12); background:#fff; color:rgba(74,59,54,0.35); border-radius:10px; padding:10px 16px; font-size:13.5px; font-weight:700; cursor:not-allowed; text-decoration:line-through;">${esc(sz)} <span style="text-decoration:none; font-weight:600; font-size:10.5px; opacity:0.85;">(${I18N.outOfStockLabel})</span></button>`;
              }
              return `<button type="button" data-size="${esc(sz)}" style="border:2px solid ${active ? '#A794DD' : 'rgba(74,59,54,0.2)'}; background:${active ? '#A794DD' : '#fff'}; color:${active ? '#FBF1E3' : '#4A3B36'}; border-radius:10px; padding:10px 16px; font-size:13.5px; font-weight:700; cursor:pointer;">${esc(sz)}</button>`;
            })
            .join('')}
        </div>`;
    }

    if (key === 'color') {
      const cat = currentCategory();
      const colors = colorsForCategory();
      const sizeLabel = cat && cat.sizeType !== 'one_size' ? state.size : null;
      const noneAvailable =
        !!cat && cat.hasLinkedProduct && colors.length > 0 && !colors.some((c) => isColorAvailable(cat, sizeLabel, c.label));
      return `<h3 style="font-weight:600; font-size:19px; margin:0 0 4px;">${I18N.chooseColorTitle}</h3>
        <p style="font-size:13px; color:#4A3B36; opacity:0.6; margin:0 0 16px;">${state.color ? colorLabel(state.color) : I18N.notSelected}</p>
        ${noneAvailable ? `<p style="font-size:12.5px; background:#FFF4E5; color:#8A5A00; padding:10px 14px; border-radius:10px; margin:0 0 14px; line-height:1.5;">${I18N.noColorsForSize || ''}</p>` : ''}
        <div style="display:flex; gap:12px; flex-wrap:wrap; margin-bottom:24px;">
          ${colors
            .map((c) => {
              const active = state.color === c.label;
              const available = isColorAvailable(cat, sizeLabel, c.label);
              if (!available) {
                return `<button type="button" disabled title="${colorLabel(c.label)} (${I18N.outOfStockLabel})" style="width:38px; height:38px; border-radius:50%; background:${c.hex}; border:2px solid rgba(74,59,54,0.12); cursor:not-allowed; opacity:0.35; background-image:repeating-linear-gradient(45deg, rgba(255,255,255,0.9) 0, rgba(255,255,255,0.9) 2px, transparent 2px, transparent 5px);"></button>`;
              }
              const border = active ? '3px solid #A794DD' : '2px solid rgba(74,59,54,0.15)';
              return `<button type="button" data-color="${esc(c.label)}" data-hex="${esc(c.hex)}" data-image="${esc(c.image || '')}" title="${colorLabel(c.label)}" style="width:38px; height:38px; border-radius:50%; background:${c.hex}; border:${border}; cursor:pointer;"></button>`;
            })
            .join('')}
        </div>`;
    }

    if (key === 'type') {
      return `<h3 style="font-weight:600; font-size:19px; margin:0 0 4px;">${I18N.chooseTypeTitle}</h3>
        <p style="font-size:13px; color:#4A3B36; opacity:0.6; margin:0 0 16px;">${state.personalizeType ? (state.personalizeType === 'text' ? I18N.personalizeTypeText : I18N.personalizeTypeLogo) : I18N.notSelected}</p>
        <div style="display:flex; gap:10px; margin-bottom:16px;">
          ${['text', 'logo']
            .map((ptype) => {
              const active = state.personalizeType === ptype;
              const label = ptype === 'text' ? I18N.personalizeTypeText : I18N.personalizeTypeLogo;
              return `<button type="button" data-ptype="${ptype}" style="flex:1; border:2px solid ${active ? '#A794DD' : 'rgba(74,59,54,0.2)'}; background:${active ? '#A794DD' : '#fff'}; color:${active ? '#FBF1E3' : '#4A3B36'}; border-radius:12px; padding:14px 10px; font-size:14px; font-weight:700; cursor:pointer;">${label}</button>`;
            })
            .join('')}
        </div>`;
    }

    if (key === 'placement') {
      const cat = currentCategory();
      const restricted = !!(cat && cat.placementRestricted);
      const currentPlacementLabel = state.placement
        ? restricted || state.placement === 'Hand/Arm Side'
          ? placementLabel(state.placement)
          : `${placementLabel(state.placement)} ${state.placementLarge ? '(13×18cm)' : '(10×10cm)'}`
        : I18N.notSelected;
      return `<h3 style="font-weight:600; font-size:19px; margin:0 0 4px;">${I18N.choosePlacementTitle}</h3>
        <p style="font-size:13px; color:#4A3B36; opacity:0.6; margin:0 0 16px;">${currentPlacementLabel}</p>
        <div style="display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:16px;">
          ${placementsForCategory().map((p) => {
            const active = state.placement === p.label && state.placementLarge === p.large;
            const sizeSuffix = restricted || p.key === 'arm' ? '' : esc(p.size || '(10×10cm)');
            const fee = feeForPlacement(p);
            return `<button type="button" data-placement="${esc(p.label)}" data-large="${p.large}" style="border:2px solid ${active ? '#A794DD' : 'rgba(74,59,54,0.2)'}; background:${active ? '#A794DD' : '#fff'}; color:${active ? '#FBF1E3' : '#4A3B36'}; border-radius:12px; padding:14px 10px; font-size:13.5px; font-weight:700; cursor:pointer; text-align:left;">${placementLabel(p.label)} ${sizeSuffix}${fee > 0 ? `<span style="display:block; font-weight:600; font-size:11.5px; opacity:0.75; margin-top:3px;">+CHF ${fee.toFixed(2)}</span>` : ''}</button>`;
          }).join('')}
        </div>
        ${cat && cat.placementRestricted ? `<p style="font-size:12px; background:#FBF1E3; color:#4A3B36; padding:12px 14px; border-radius:10px; margin:0 0 16px; line-height:1.5;">${I18N.placementHatNote}</p>` : ''}`;
    }

    if (key === 'personalize') {
      const cat = currentCategory();
      const restricted = !!(cat && cat.placementRestricted);
      const { maxLines, maxChars } = textLineLimits();
      return `<h3 style="font-weight:600; font-size:19px; margin:0 0 16px;">${I18N.personalizeTitle}</h3>
        ${
          state.personalizeType === 'text'
            ? `${Array.from({ length: maxLines }, (_, i) => {
                 const n = i + 1;
                 const placeholder = (I18N.textLinePlaceholder || '').replace('%LINE%', n).replace('%MAX%', maxChars);
                 return `<input id="text-line-${n}" type="text" maxlength="${maxChars}" placeholder="${esc(placeholder)}" style="width:100%; box-sizing:border-box; padding:12px 14px; border-radius:10px; border:1px solid rgba(74,59,54,0.2); font-size:14px; margin-bottom:${n === maxLines ? '14px' : '10px'};"/>`;
               }).join('')}
               <p style="font-style:italic; font-family:'Cormorant Garamond', serif; font-size:16px; color:#4A3B36; opacity:0.85; margin:0 0 20px;">${(I18N.textLinesNote || '').replace('%LINES%', maxLines).replace('%MAX%', maxChars)}</p>
               <p style="font-weight:700; font-size:13.5px; margin:0 0 8px;">${I18N.fontStyleLabel}</p>
               <div style="display:grid; grid-template-columns:repeat(auto-fill, minmax(110px, 1fr)); gap:10px; margin-bottom:18px;">
                 ${FONT_STYLES.map((f) => {
                   const active = state.fontStyle === f;
                   const img = FONT_IMAGES[f];
                   const border = active ? '3px solid #A794DD' : '2px solid rgba(74,59,54,0.15)';
                   const preview = img
                     ? `<img src="${esc(img)}" alt="${esc(f)}" style="width:100%; height:64px; object-fit:contain; background:#FBF1E3; display:block;">`
                     : `<div style="width:100%; height:64px; background:#FBF1E3; display:flex; align-items:center; justify-content:center; font-size:11px; color:#8A8177; text-align:center; padding:0 6px;">${esc(f)}</div>`;
                   return `<button type="button" data-font="${esc(f)}" style="border:${border}; background:#fff; border-radius:12px; padding:0; overflow:hidden; cursor:pointer; text-align:left;">
                     ${preview}
                     <span style="display:block; padding:6px 8px; font-size:11.5px; font-weight:700; color:${active ? '#A794DD' : '#4A3B36'};">${esc(f)}</span>
                   </button>`;
                 }).join('')}
               </div>
               <p style="font-weight:700; font-size:13.5px; margin:0 0 6px;">${I18N.threadColorLabel}</p>
               <input id="thread-color" type="text" placeholder="${I18N.threadColorPlaceholder}" value="${esc(state.threadColorNumber)}" style="width:100%; box-sizing:border-box; padding:12px 14px; border-radius:10px; border:1px solid ${state.threadColorNumber.trim() && !isValidThreadColor(state.threadColorNumber) ? '#C0392B' : 'rgba(74,59,54,0.2)'}; font-size:14px;"/>
               <p id="thread-color-hint" style="font-size:12px; color:#4A3B36; opacity:0.65; margin:6px 0 14px;">${I18N.threadColorHint}</p>
               <p id="thread-color-error" style="font-size:12px; color:#C0392B; margin:-10px 0 14px; display:${state.threadColorNumber.trim() && !isValidThreadColor(state.threadColorNumber) ? 'block' : 'none'};">${I18N.threadColorError}</p>`
            : ''
        }
        ${
          state.personalizeType === 'logo'
            ? `<p style="font-size:13px; background:#FBF1E3; color:#4A3B36; padding:12px 14px; border-radius:10px; margin:0 0 20px; line-height:1.5;">${I18N.logoUploadNote}</p>`
            : ''
        }
        ${
          restricted
            ? `<div style="border:1px solid rgba(74,59,54,0.15); border-radius:12px; padding:14px 16px; margin:0 0 ${state.hatExtraText ? '10px' : '20px'}; display:flex; align-items:flex-start; gap:10px;">
                 <input type="checkbox" id="hat-extra-text-toggle" ${state.hatExtraText ? 'checked' : ''} style="margin-top:3px; cursor:pointer;">
                 <label for="hat-extra-text-toggle" style="cursor:pointer; flex:1;">
                   <span style="display:block; font-weight:700; font-size:13.5px;">${I18N.hatExtraTextLabel}</span>
                   <span style="display:block; font-size:12px; opacity:0.65; margin-top:2px;">${I18N.hatExtraTextHint}</span>
                 </label>
                 <span style="background:#FBF1E3; color:#A794DD; font-size:11.5px; font-weight:700; padding:4px 10px; border-radius:100px; white-space:nowrap;">+CHF ${PRICE_HAT_EXTRA_TEXT.toFixed(2)}</span>
               </div>
               ${state.hatExtraText ? `<input id="hat-extra-text-value" type="text" maxlength="6" placeholder="${I18N.hatExtraTextPlaceholder}" style="width:100%; box-sizing:border-box; padding:12px 14px; border-radius:10px; border:1px solid rgba(74,59,54,0.2); font-size:14px; margin-bottom:20px;"/>` : ''}`
            : ''
        }
        <p style="font-size:13px; color:#4A3B36; opacity:0.75; margin:0;">${I18N.specialRequestNote} <a href="mailto:${esc(I18N.specialRequestEmail)}" style="color:#A794DD; font-weight:700;">${esc(I18N.specialRequestEmail)}</a></p>`;
    }

    // upload step
    return `<h3 style="font-weight:600; font-size:19px; margin:0 0 6px;">${I18N.uploadTitle}</h3>
      <p style="font-size:13px; color:#4A3B36; opacity:0.6; margin:0 0 16px;">${I18N.uploadSubtitle}</p>
      <div style="background:#EAF3ED; color:#4E7A61; font-size:13px; padding:12px 14px; border-radius:10px; margin-bottom:16px; line-height:1.5;">${I18N.uploadNote}</div>
      <label style="display:flex; flex-direction:column; align-items:center; justify-content:center; gap:8px; border:2px dashed #A794DD; border-radius:14px; padding:36px 20px; cursor:pointer; margin-bottom:20px;">
        <input id="upload-file" type="file" accept="image/*" style="display:none;"/>
        <span style="width:36px; height:36px; border-radius:50%; background:#FBF1E3; display:flex; align-items:center; justify-content:center;">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 16V4M12 4l-4 4M12 4l4 4" stroke="#A794DD" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 16v3a2 2 0 002 2h12a2 2 0 002-2v-3" stroke="#A794DD" stroke-width="1.8" stroke-linecap="round"/></svg>
        </span>
        <span id="upload-label" style="font-size:14px; font-weight:700; color:#A794DD;">${state.fileName ? esc(state.fileName) : I18N.clickToUpload}</span>
        <span style="font-size:12px; color:#4A3B36; opacity:0.55;">${I18N.uploadFilesize}</span>
      </label>`;
  }

  function attachStepContentListeners() {
    el.stepContent.querySelectorAll('[data-category]').forEach((btn) => {
      btn.addEventListener('click', () => finalizeCategory(btn.dataset.category));
    });
    el.stepContent.querySelectorAll('[data-group]').forEach((btn) => {
      btn.addEventListener('click', () => selectGroup(btn.dataset.group));
    });
    el.stepContent.querySelectorAll('[data-size]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.size = btn.dataset.size;
        const cat = currentCategory();
        if (state.color && !isColorAvailable(cat, state.size, state.color)) {
          state.color = null;
          state.colorHex = null;
          state.colorImage = null;
        }
        render();
      });
    });
    el.stepContent.querySelectorAll('[data-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.color = btn.dataset.color;
        state.colorHex = btn.dataset.hex;
        state.colorImage = btn.dataset.image || null;
        state.activeImage = 0;
        render();
      });
    });
    el.stepContent.querySelectorAll('[data-placement]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.placement = btn.dataset.placement;
        state.placementLarge = btn.dataset.large === 'true';
        const { maxLines, maxChars } = textLineLimits();
        state.textLines = state.textLines.slice(0, maxLines).map((line) => line.slice(0, maxChars));
        render();
      });
    });

    el.stepContent.querySelectorAll('[data-ptype]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.personalizeType = btn.dataset.ptype;
        state.placement = null;
        state.placementLarge = false;
        render();
      });
    });

    el.stepContent.querySelectorAll('input[id^="text-line-"]').forEach((input, i) => {
      input.value = state.textLines[i] || '';
      input.addEventListener('input', (e) => {
        state.textLines[i] = e.target.value;
        updatePrice();
      });
    });
    el.stepContent.querySelectorAll('[data-font]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.fontStyle = btn.dataset.font;
        render();
      });
    });
    const threadColorInput = el.stepContent.querySelector('#thread-color');
    if (threadColorInput) {
      threadColorInput.value = state.threadColorNumber;
      threadColorInput.addEventListener('input', (e) => {
        state.threadColorNumber = e.target.value;
        const valid = isValidThreadColor(state.threadColorNumber);
        const showError = !!state.threadColorNumber.trim() && !valid;
        threadColorInput.style.borderColor = showError ? '#C0392B' : 'rgba(74,59,54,0.2)';
        const errorEl = el.stepContent.querySelector('#thread-color-error');
        if (errorEl) errorEl.style.display = showError ? 'block' : 'none';
        updatePrice();
      });
    }
    const hatExtraTextToggle = el.stepContent.querySelector('#hat-extra-text-toggle');
    if (hatExtraTextToggle) {
      hatExtraTextToggle.addEventListener('change', (e) => {
        state.hatExtraText = e.target.checked;
        if (!state.hatExtraText) state.hatExtraTextValue = '';
        render();
      });
    }
    const hatExtraTextValueInput = el.stepContent.querySelector('#hat-extra-text-value');
    if (hatExtraTextValueInput) {
      hatExtraTextValueInput.value = state.hatExtraTextValue;
      hatExtraTextValueInput.addEventListener('input', (e) => {
        state.hatExtraTextValue = e.target.value;
      });
    }

    const fileInput = el.stepContent.querySelector('#upload-file');
    if (fileInput) {
      fileInput.addEventListener('change', (e) => {
        const f = e.target.files && e.target.files[0];
        if (f) {
          state.fileName = f.name;
          render();
        }
      });
    }
  }

  // Merchant-only, one-time check (categories don't change during a session): flags any category
  // whose linked product has size labels that don't match, so setup mistakes are visible instead
  // of silently showing sizes as sold out. Only renders in the theme editor (design mode).
  function renderInventoryWarnings() {
    if (!DESIGN_MODE || !el.inventoryWarnings) return;
    const lines = [];
    categories.forEach((cat) => {
      if (!cat.hasLinkedProduct) return;

      if (cat.sizeType === 'one_size') {
        if (cat.hasSizeOption) {
          lines.push((I18N.inventoryUnexpectedSizeWarning || '').replace('%CATEGORY%', cat.name));
        }
        if (!cat.hasColorOption) {
          if (!stockEntry(cat, null, null)) {
            lines.push((I18N.inventoryNoMatchWarning || '').replace('%CATEGORY%', cat.name).replace('%TOTAL%', '1'));
          }
          return;
        }
        const oneSizeColors = colorsFor(cat);
        if (oneSizeColors.length && !oneSizeColors.some((c) => stockEntry(cat, null, c.label))) {
          lines.push(
            (I18N.inventoryNoMatchWarning || '').replace('%CATEGORY%', cat.name).replace('%TOTAL%', String(oneSizeColors.length))
          );
        }
        return;
      }

      if (!cat.hasSizeOption) {
        lines.push((I18N.inventoryMissingOptionWarning || '').replace('%CATEGORY%', cat.name).replace('%OPTION%', 'Size'));
        return;
      }

      const sizes = cat.sizeType === 'adult' ? ADULT_SIZES : KIDS_SIZES;

      if (!cat.hasColorOption) {
        const unmatched = sizes.filter((sz) => !stockEntry(cat, sz, null));
        if (unmatched.length === sizes.length) {
          lines.push((I18N.inventoryNoMatchWarning || '').replace('%CATEGORY%', cat.name).replace('%TOTAL%', String(sizes.length)));
        } else {
          unmatched.forEach((sz) => {
            lines.push((I18N.inventoryMismatchWarning || '').replace('%CATEGORY%', cat.name).replace('%SIZE%', sz));
          });
        }
        return;
      }

      const comboColors = colorsFor(cat);
      if (!comboColors.length) return;
      let matchedCombos = 0;
      sizes.forEach((sz) => {
        comboColors.forEach((c) => {
          if (stockEntry(cat, sz, c.label)) matchedCombos += 1;
        });
      });
      if (matchedCombos === 0) {
        lines.push(
          (I18N.inventoryNoMatchWarning || '')
            .replace('%CATEGORY%', cat.name)
            .replace('%TOTAL%', String(sizes.length * comboColors.length))
        );
      }
    });
    if (!lines.length) {
      el.inventoryWarnings.innerHTML = '';
      return;
    }
    el.inventoryWarnings.innerHTML = `<div style="background:#FFF4E5; border:1px solid #E8B84B; border-radius:10px; padding:14px 16px; margin-bottom:18px;">
      <p style="font-weight:700; font-size:13px; margin:0 0 8px; color:#8A5A00;">⚠ Inventory setup — only visible to you in the theme editor</p>
      ${lines.map((l) => `<p style="font-size:12.5px; color:#8A5A00; margin:0 0 4px; line-height:1.5;">${esc(l)}</p>`).join('')}
    </div>`;
  }

  function updateCartBubble() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
        if (bubble) bubble.textContent = cart.item_count < 100 ? cart.item_count : bubble.textContent;
      })
      .catch(() => {});
  }

  function addToCart() {
    if (!isPersonalizationComplete()) {
      state.cartError = I18N.cartErrorIncomplete || I18N.cartErrorGeneric;
      render();
      return;
    }
    const cat = currentCategory();
    const variantId = resolveVariantId(cat);
    if (!variantId) {
      state.cartError = cat && cat.hasLinkedProduct ? I18N.cartErrorOutOfStock || I18N.cartErrorGeneric : I18N.cartErrorGeneric;
      render();
      return;
    }
    state.adding = true;
    state.cartError = null;
    render();

    const properties = {
      Category: cat ? cat.name : '',
      Size: state.size || '',
      Color: state.color ? colorLabel(state.color) : '',
      Placement: state.placement ? placementLabel(state.placement) : '',
      'Estimated price': `CHF ${calcPrice().toFixed(2)}`,
    };
    if (state.personalizeType === 'text' && state.textLines.some((line) => line.trim())) {
      properties['Personalization'] = state.textLines.map((line) => line.trim()).filter(Boolean).join(' / ');
      if (state.fontStyle) properties['Font style'] = state.fontStyle;
      if (state.threadColorNumber.trim()) properties['Thread color number'] = state.threadColorNumber.trim();
    }
    if (state.personalizeType === 'logo') properties['Personalization type'] = 'Logo';
    if (state.hatExtraText && state.hatExtraTextValue.trim()) {
      properties['Extra back/side text'] = state.hatExtraTextValue.trim();
    }
    if (state.fileName) properties['Reference file'] = state.fileName;

    const cartNotification = document.querySelector('cart-notification');
    const cartDrawer = document.querySelector('cart-drawer');
    const cartUi = cartNotification || cartDrawer;

    function buildCartAddFormData(id, quantity, itemProperties) {
      const fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', quantity);
      Object.keys(itemProperties || {}).forEach((key) => {
        fd.append(`properties[${key}]`, itemProperties[key]);
      });
      if (cartUi) {
        const sectionIds = cartUi.getSectionsToRender().map((s) => s.id || s.section);
        fd.append('sections', sectionIds.join(','));
        fd.append('sections_url', window.location.pathname);
      }
      return fd;
    }

    function postCartAdd(fd) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: fd,
      }).then(async (res) => {
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || I18N.cartErrorGeneric);
        }
        return res.json().catch(() => null);
      });
    }

    postCartAdd(buildCartAddFormData(variantId, state.qty, properties))
      .then((added) => {
        const reasons = surchargeReasons();
        if (reasons.length === 0) return added;
        const itemTitle = (cat && cat.name) || '';
        // Add each real surcharge as its own cart line, one request at a time (Shopify's cart
        // isn't safe for concurrent writes). Re-requesting the same sections on every call means
        // the LAST response reflects every line added so far, which is what the popup should show.
        return reasons
          .reduce((chain, reason) => {
            return chain.then(() => {
              const surchargeVariant = surchargeVariantId(reason.amount);
              if (!surchargeVariant) {
                console.warn(`hz-configurator: no surcharge variant configured for CHF ${reason.amount}`);
                return null;
              }
              const props = {};
              props[I18N.forItemProperty || 'For item'] = `${itemTitle} — ${reason.label}`;
              return postCartAdd(buildCartAddFormData(surchargeVariant, 1, props));
            });
          }, Promise.resolve(null))
          .then((lastSurchargeResult) => lastSurchargeResult || added);
      })
      .then((finalAdded) => {
        state.adding = false;
        state.justAdded = true;
        render();
        if (cartUi && finalAdded) {
          try {
            cartUi.renderContents(finalAdded);
          } catch (renderError) {
            console.error('hz-configurator: cart notification render failed', renderError, finalAdded);
            updateCartBubble();
          }
        } else {
          updateCartBubble();
        }
      })
      .catch((e) => {
        state.adding = false;
        state.cartError = e.message || I18N.cartErrorGeneric;
        render();
      });
  }

  function render() {
    const s = state;
    renderGallery();
    updatePrice();

    // Tabs
    const steps = activeStepKeys();
    const totalSteps = steps.length;
    const unlocked = maxUnlockedStep();
    el.tabs.innerHTML = steps
      .map((key, i) => ({ key, i }))
      .filter(({ key }) => key !== 'upload')
      .map(({ key, i }) => {
        const label = STEP_LABEL_MAP[key];
        const active = i === s.step;
        const locked = i > unlocked;
        const bg = active ? '#A794DD' : '#FBF1E3';
        const color = active ? '#FBF1E3' : locked ? 'rgba(74,59,54,0.35)' : '#4A3B36';
        const cursor = locked ? 'not-allowed' : 'pointer';
        return `<button type="button" data-step="${i}" class="hz-tab" style="flex:1; white-space:nowrap; border:none; cursor:${cursor}; padding:11px 14px; border-radius:10px; font-size:13px; font-weight:700; background:${bg}; color:${color};">${label}</button>`;
      })
      .join('');
    el.tabs.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => goTo(parseInt(btn.dataset.step, 10)));
    });

    // Progress
    el.progressBar.style.width = `${((s.step + 1) / totalSteps) * 100}%`;
    el.stepNumberLabel.textContent = (I18N.stepOf || 'Step %CURRENT% of %TOTAL%')
      .replace('%CURRENT%', s.step + 1)
      .replace('%TOTAL%', totalSteps);
    el.stepsToGoLabel.textContent =
      s.step === totalSteps - 1
        ? I18N.finalStep
        : (I18N.stepsToGo || '%COUNT% steps to go').replace('%COUNT%', totalSteps - 1 - s.step);

    // Step content — crossfade only when the step actually changed (not on every
    // in-step interaction like picking a color), and skip the animation entirely
    // for prefers-reduced-motion.
    const stepChanged = lastRenderedStep !== null && lastRenderedStep !== s.step;
    lastRenderedStep = s.step;
    if (stepChanged && !PREFERS_REDUCED_MOTION) {
      el.stepContent.style.transition = 'opacity 150ms ease';
      el.stepContent.style.opacity = '0';
      setTimeout(() => {
        el.stepContent.innerHTML = stepContentHtml();
        attachStepContentListeners();
        requestAnimationFrame(() => {
          el.stepContent.style.opacity = '1';
        });
      }, 150);
    } else {
      el.stepContent.innerHTML = stepContentHtml();
      attachStepContentListeners();
    }

    // Nav buttons
    el.backBtn.style.display = s.step > 0 ? '' : 'none';
    const isLastStep = s.step === totalSteps - 1;
    el.cartControls.style.display = isLastStep ? 'flex' : 'none';
    el.nextBtn.style.display = isLastStep || !categories.length ? 'none' : '';
    el.nextBtn.disabled = !isStepComplete(s.step);
    el.nextBtn.style.opacity = el.nextBtn.disabled ? '0.5' : '1';
    el.nextBtn.style.cursor = el.nextBtn.disabled ? 'not-allowed' : 'pointer';
    el.qtyVal.textContent = s.qty;
    el.justAdded.style.display = s.justAdded ? '' : 'none';
    el.cartErrorEl.style.display = s.cartError ? '' : 'none';
    el.cartErrorEl.textContent = s.cartError || '';
    el.addToCartBtn.disabled = s.adding || !isPersonalizationComplete();
    el.addToCartBtn.style.opacity = el.addToCartBtn.disabled ? '0.5' : '1';
    el.addToCartBtn.style.cursor = el.addToCartBtn.disabled ? 'not-allowed' : 'pointer';
    el.addToCartBtn.textContent = s.adding ? I18N.adding : I18N.addToCart;

    // Accordion
    el.accordion.innerHTML = accordionData()
      .map((a, i) => {
        const open = s.openAccordion === i;
        return `<div style="border-bottom:1px solid rgba(74,59,54,0.12); padding:16px 0;">
          <button data-idx="${i}" class="accordion-toggle" style="width:100%; background:none; border:none; display:flex; align-items:center; justify-content:space-between; cursor:pointer; padding:0; font-size:15px; font-weight:700; color:#4A3B36;">
            ${a.title}<span style="font-size:18px; color:#A794DD;">${open ? '−' : '+'}</span>
          </button>
          ${open ? `<p style="font-size:13.5px; line-height:1.6; color:#4A3B36; opacity:0.75; margin:12px 0 0;">${a.body}</p>` : ''}
        </div>`;
      })
      .join('');
    el.accordion.querySelectorAll('.accordion-toggle').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.idx, 10);
        state.openAccordion = state.openAccordion === idx ? null : idx;
        render();
      });
    });
  }

  el.backBtn.addEventListener('click', back);
  el.nextBtn.addEventListener('click', next);
  el.qtyInc.addEventListener('click', () => {
    state.qty += 1;
    render();
  });
  el.qtyDec.addEventListener('click', () => {
    state.qty = Math.max(1, state.qty - 1);
    render();
  });
  el.addToCartBtn.addEventListener('click', addToCart);

  if (categories.length) {
    const initialCat = currentCategory();
    if (initialCat && initialCat.groupName) state.groupName = initialCat.groupName;
    state.size = initialCat && initialCat.sizeType === 'one_size' ? I18N.oneSizeLabel || 'One size' : firstAvailableSize(initialCat);
  }
  renderInventoryWarnings();
  render();
})();
